import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import Scene3D from "./Scene3D";
import { company } from "../mock";

const word = {
  hidden: { y: "110%" },
  show: (i) => ({
    y: 0,
    transition: { delay: 0.2 + i * 0.12, duration: 0.9, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "40%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.6], [1, 0]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.9]);

  return (
    <section id="home" ref={ref} className="relative min-h-screen overflow-hidden">
      <Scene3D />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#0a0a0b]/10 via-transparent to-[#0a0a0b]" />

      {/* side labels */}
      <div className="absolute left-6 top-1/2 hidden -translate-y-1/2 md:block md:left-12">
        <span className="font-display text-xs uppercase tracking-[0.3em] text-[#8a8a86] [writing-mode:vertical-rl]">
          {company.role1}
        </span>
      </div>
      <div className="absolute right-6 top-1/2 hidden -translate-y-1/2 md:block md:right-12">
        <span className="font-display text-xs uppercase tracking-[0.3em] text-[#8a8a86] [writing-mode:vertical-rl] rotate-180">
          {company.role2}
        </span>
      </div>

      <motion.div style={{ y, opacity, scale }} className="relative z-10 mx-auto flex min-h-screen max-w-[1600px] flex-col justify-center px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.1, duration: 1 }}
          className="mb-6 max-w-md text-sm leading-relaxed text-[#c9c9c4] md:text-base"
        >
          Building custom software, mobile apps & CRMs — globally, from {company.location}.
        </motion.p>

        <h1 className="font-display font-bold uppercase leading-[0.85] tracking-tight">
          {["We build", "software", "that scales"].map((line, i) => (
            <span key={i} className="block overflow-hidden">
              <motion.span
                custom={i}
                variants={word}
                initial="hidden"
                animate="show"
                className={`block text-[15vw] leading-[0.85] md:text-[10vw] ${
                  i === 1 ? "text-[#d4ff4e]" : "text-[#f4f4f0]"
                }`}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4 }}
        className="absolute bottom-8 left-1/2 z-10 flex -translate-x-1/2 flex-col items-center gap-2"
      >
        <span className="font-display text-[10px] uppercase tracking-[0.3em] text-[#8a8a86]">Scroll</span>
        <motion.div animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 1.6 }}>
          <ArrowDown size={16} className="text-[#d4ff4e]" />
        </motion.div>
      </motion.div>
    </section>
  );
}
